import * as React from "react";
import { Checkbox as BaseCheckbox } from "@base-ui/react/checkbox";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

function Checkbox({ className, ...props }: React.ComponentProps<typeof BaseCheckbox.Root>) {
  return (
    <BaseCheckbox.Root
      className={cn(
        "inline-flex size-4 shrink-0 items-center justify-center rounded-[3px] border border-control bg-canvas text-canvas outline-hidden transition-colors data-checked:border-ink data-checked:bg-ink focus-visible:ring-2 focus-visible:ring-focus disabled:cursor-not-allowed disabled:opacity-45 pointer-coarse:size-11",
        className,
      )}
      {...props}
    >
      <BaseCheckbox.Indicator><Check className="size-3" aria-hidden="true" /></BaseCheckbox.Indicator>
    </BaseCheckbox.Root>
  );
}

export { Checkbox };
